import GraphicDisplay from './graphic-display';
export default GraphicDisplay;
